import React from "react";
import { Box } from "@mui/material";
import ViewToggle from "./ViewToggle";
import ServicesGantt from "../ServicesGantt";
import { useFilters } from "components/Elements/Filters/FilterContext";

const ServicesView = ({
	children,
	onGanttServiceSelect,
	onViewChange,
	ganttRefreshRevision,
}) => {
	const { filterValues } = useFilters();

	// Get current view from filter state, defaulting to 'table'
	const view = filterValues.viewToggle?.value?.id || "table";

	const handleViewChange = (newView) => {
		onViewChange?.(newView);
	};

	return (
		<Box>
			<Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
				<ViewToggle onViewChange={handleViewChange} />
			</Box>

			{view === "table" ? (
				<Box>{children}</Box>
			) : (
				<ServicesGantt
					onServiceSelect={onGanttServiceSelect}
					refreshRevision={ganttRefreshRevision}
				/>
			)}
		</Box>
	);
};

export default ServicesView;
